import { s as h, x as d, i as L, r as c, e as p } from "../../query-assigned-elements-96a4d233.mjs";
import { n as l } from "../../property-9b6ea53b.mjs";
import "../../components/page-footer/index.js";
import "../../index-19a5caf5.mjs";
const f = `:host{--font-regular: "Circular Std Medium", Helvetica, Arial, sans-serif;--font-regular-italic: "Circular Std Medium Italic", Helvetica, Arial, sans-serif;--font-thin: "Circular Std Book", Helvetica, Arial, sans-serif;--font-thin-italic: "Circular Std Book Italic", Helvetica, Arial, sans-serif;--font-bold: "Circular Std Bold", Helvetica, Arial, sans-serif;--font-bold-italic: "Circular Std Bold Italic", Helvetica, Arial, sans-serif;font-size:16px;--fs-xxl: 40px;--fs-xl: 35px;--fs-l: 25px;--fs-m: 19px;--fs-s: 16px;--fs-xs: 14px;--padding-inline: 2em;--padding-block: 2em;--max-width-main-content: 500px;--max-width-menu: 350px;--height-top-menu: 5em;--width-side-menu: 22em;--max-width-search-menu: 550px}@media screen and (max-width: 390px){:host{--fs-xxl: 37px;--fs-xl: 30px;--fs-l: 25px;--fs-m: 18px;--fs-s: 16px;--fs-xs: 14px}}@media screen and (max-width: 1300px){:host{--padding-inline: 1.5em;--padding-block: 1.5em}}@media screen and (max-width: 500px){:host{--padding-inline: 1em;--padding-block: 1.5em}}h1,h2,h3,h4,h5{font-family:var(--font-bold);color:#31273e;margin-block:.5em}h1{font-size:var(--fs-xxl);line-height:1.2}h2{font-size:var(--fs-xl)}h3{font-size:var(--fs-l)}h4{font-size:var(--fs-m)}h5{font-size:var(--fs-s)}p,span,address{font-family:var(--font-thin);font-size:var(--fs-s);color:#919191;line-height:initial;padding:initial;line-height:1.5}a{font-size:1em;color:#00a3ff;text-decoration:underline;cursor:pointer}div{font-family:var(--font-thin);color:#919191;line-height:1}button{display:flex;align-items:center;gap:1.2em;padding:.6em 1.5em;border-radius:1.8em;font-size:1em;cursor:pointer;font-family:var(--font-regular);transition:all .2s ease-in-out;border:none}.gray-box{background-color:#f6f6f6;padding:1.5em;border-radius:.5em;border:1px solid #e0e0e0;text-align:center}.page-container{display:flex;flex-direction:column;height:100%;min-height:100svh;overflow-x:hidden;overflow-y:auto;margin:0;padding:0}.page-container .page-content{display:flex;flex-direction:column;align-items:center;justify-content:center;overflow:hidden;gap:3em;font-size:.9em;justify-self:center;align-self:center;flex:1;padding:var(--padding-block) var(--padding-inline)}.page-container .page-content h2{margin:0;text-align:center}.page-container .page-massage{color:#919191;background-color:#f5f5f5;max-width:var(--max-width-main-content);border-radius:1em;padding:1em var(--padding-inline);height:max-content}.page-container .page-massage>*{text-align:center}@media screen and (max-width: 500px){.page-container .page-massage{border-radius:0;max-width:initial;margin-inline:calc(var(--padding-inline) * -1)}}.page-container .page-illustration{width:100%;max-width:var(--max-width-main-content)}.page-container .page-illustration svg{width:100%;max-height:350px}button{display:flex;align-items:center;justify-content:center;border-radius:2em;padding:.8em 3em;font-size:1em;background-color:#75d3a8;color:#fff;border:none;cursor:pointer;transition:background-color .3s;outline:none;font-size:var(--fs-m)}button:hover{filter:brightness(1.1)}button:active{filter:brightness(.9)}button:focus{outline:none}
`;
var g = Object.defineProperty, k = Object.getOwnPropertyDescriptor, o = (C, i, n, r) => {
  for (var t = r > 1 ? void 0 : r ? k(i, n) : i, a = C.length - 1, s; a >= 0; a--)
    (s = C[a]) && (t = (r ? s(i, n, t) : s(t)) || t);
  return r && t && g(i, n, t), t;
};
let e = class extends h {
  constructor() {
    super(...arguments), this.illustrationSVG = d`
      <svg viewBox="0 0 489 286" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path
            d="M136.727 203.829C123.728 193.064 135.572 179.346 126.411 179.346C119.108 179.643 121.776 185.686 121.776 187.381"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
         />
         <path
            d="M348.879 203.829C361.879 193.064 350.034 179.346 359.195 179.346C366.499 179.643 363.831 185.686 363.831 187.381"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
         />
         <rect
            x="107.127"
            y="171.881"
            width="9.37837"
            height="92.5108"
            fill="#D2D5DC"
            stroke="black"
            stroke-width="0.7"
         />
         <circle
            cx="111.817"
            cy="165.006"
            r="9.37144"
            fill="#3F3350"
            stroke="black"
            stroke-width="0.7"
         />
         <mask id="path-5-inside-1_604_977" fill="white">
            <path
               d="M127.655 274.225C127.655 272.7 127.245 271.19 126.449 269.782C125.653 268.373 124.486 267.093 123.016 266.014C121.545 264.936 119.799 264.081 117.877 263.497C115.956 262.914 113.896 262.613 111.817 262.613C109.737 262.613 107.677 262.914 105.756 263.497C103.834 264.081 102.088 264.936 100.617 266.014C99.1467 267.093 97.98 268.373 97.1841 269.782C96.3882 271.19 95.9785 272.7 95.9785 274.225L111.817 274.225H127.655Z"
            />
         </mask>
         <path
            d="M127.655 274.225C127.655 272.7 127.245 271.19 126.449 269.782C125.653 268.373 124.486 267.093 123.016 266.014C121.545 264.936 119.799 264.081 117.877 263.497C115.956 262.914 113.896 262.613 111.817 262.613C109.737 262.613 107.677 262.914 105.756 263.497C103.834 264.081 102.088 264.936 100.617 266.014C99.1467 267.093 97.98 268.373 97.1841 269.782C96.3882 271.19 95.9785 272.7 95.9785 274.225L111.817 274.225H127.655Z"
            fill="#D2D5DC"
            stroke="black"
            stroke-width="1.4"
            stroke-linejoin="round"
            mask="url(#path-5-inside-1_604_977)"
         />
         <path
            d="M100.892 271.241C101.434 270 103.293 267.39 106.385 266.876"
            stroke="white"
            stroke-width="1.3"
            stroke-linecap="round"
            stroke-linejoin="round"
         />
         <rect
            x="109.457"
            y="199.818"
            width="1.63281"
            height="43.9669"
            rx="0.816406"
            fill="white"
         />
         <rect
            x="96.5534"
            y="184.586"
            width="30.5266"
            height="4.6004"
            rx="2.3002"
            fill="#D2D5DC"
            stroke="black"
            stroke-width="0.7"
         />
         <rect
            x="99.9355"
            y="185.948"
            width="6.4502"
            height="0.93808"
            rx="0.46904"
            fill="white"
         />
         <path
            d="M105.382 164.981C105.622 163.632 106.788 160.625 109.539 159.391"
            stroke="white"
            stroke-width="1.3"
            stroke-linecap="round"
            stroke-linejoin="round"
         />
         <rect
            x="371.68"
            y="171.881"
            width="9.37837"
            height="92.5108"
            fill="#D2D5DC"
            stroke="black"
            stroke-width="0.7"
         />
         <circle
            cx="376.369"
            cy="165.006"
            r="9.37144"
            fill="#3F3350"
            stroke="black"
            stroke-width="0.7"
         />
         <mask id="path-13-inside-2_604_977" fill="white">
            <path
               d="M392.207 274.225C392.207 272.7 391.798 271.19 391.002 269.782C390.206 268.373 389.039 267.093 387.568 266.014C386.098 264.936 384.352 264.081 382.43 263.497C380.509 262.914 378.449 262.613 376.369 262.613C374.289 262.613 372.23 262.914 370.308 263.497C368.387 264.081 366.641 264.936 365.17 266.014C363.699 267.093 362.533 268.373 361.737 269.782C360.941 271.19 360.531 272.7 360.531 274.225L376.369 274.225H392.207Z"
            />
         </mask>
         <path
            d="M392.207 274.225C392.207 272.7 391.798 271.19 391.002 269.782C390.206 268.373 389.039 267.093 387.568 266.014C386.098 264.936 384.352 264.081 382.43 263.497C380.509 262.914 378.449 262.613 376.369 262.613C374.289 262.613 372.23 262.914 370.308 263.497C368.387 264.081 366.641 264.936 365.17 266.014C363.699 267.093 362.533 268.373 361.737 269.782C360.941 271.19 360.531 272.7 360.531 274.225L376.369 274.225H392.207Z"
            fill="#D2D5DC"
            stroke="black"
            stroke-width="1.4"
            stroke-linejoin="round"
            mask="url(#path-13-inside-2_604_977)"
         />
         <path
            d="M365.444 271.241C365.987 270 367.846 267.39 370.937 266.876"
            stroke="white"
            stroke-width="1.3"
            stroke-linecap="round"
            stroke-linejoin="round"
         />
         <rect
            x="374.01"
            y="199.818"
            width="1.63281"
            height="43.9669"
            rx="0.816406"
            fill="white"
         />
         <rect
            x="361.106"
            y="184.586"
            width="30.5266"
            height="4.6004"
            rx="2.3002"
            fill="#D2D5DC"
            stroke="black"
            stroke-width="0.7"
         />
         <rect
            x="364.488"
            y="185.948"
            width="6.4502"
            height="0.93808"
            rx="0.46904"
            fill="white"
         />
         <path
            d="M369.935 164.981C370.174 163.632 371.341 160.625 374.092 159.391"
            stroke="white"
            stroke-width="1.3"
            stroke-linecap="round"
            stroke-linejoin="round"
         />
         <path
            d="M305.866 25.114C321.609 40.689 330.495 61.7776 330.605 83.7902L330.606 84.2034V84.2047V274.298H161.84L161.84 84.2034C161.84 62.0388 170.558 40.7845 186.397 25.114C202.239 9.44145 223.726 0.635742 246.131 0.635742C268.537 0.635742 290.024 9.44146 305.866 25.114Z"
            fill="white"
            stroke="black"
         />
         <path
            d="M302.704 28.3112C317.617 43.6839 326.038 64.5028 326.142 86.2381L326.143 86.6461V86.6472V274.298H166.303L166.302 86.646C166.302 64.7607 174.564 43.7782 189.568 28.3112C204.574 12.8429 224.922 4.15582 246.136 4.15582C267.35 4.15582 287.699 12.8429 302.704 28.3112Z"
            fill="white"
            stroke="black"
         />
         <path
            d="M322.556 88.9024C322.456 67.5963 314.403 47.196 300.156 32.1382C285.82 16.9876 266.389 8.48709 246.14 8.48709C225.891 8.48709 206.46 16.9875 192.124 32.1382C177.79 47.287 169.889 67.8478 169.889 89.3046L169.89 273.798H322.557V89.307V89.3047L322.556 88.9048L322.556 88.9024ZM322.556 88.9024L323.556 88.9001L322.556 88.9024Z"
            fill="white"
            stroke="black"
            stroke-width="2"
         />
         <g opacity="0.5">
            <rect
               x="257.876"
               y="149.885"
               width="61.8019"
               height="24.8157"
               transform="rotate(30 257.876 149.885)"
               stroke="#6D6D6D"
               stroke-width="0.518011"
            />
            <path
               d="M260.375 169.426L263.921 163.285L265.309 164.086L262.425 169.082L264.949 170.539L264.44 171.773L260.375 169.426ZM271.548 172.368C271.224 172.929 270.821 173.344 270.339 173.615C269.856 173.886 269.344 174.008 268.802 173.981C268.266 173.958 267.745 173.801 267.237 173.508C266.73 173.215 266.329 172.84 266.036 172.384C265.748 171.932 265.601 171.429 265.594 170.876C265.587 170.322 265.745 169.765 266.069 169.204L266.576 168.327C266.9 167.766 267.303 167.35 267.785 167.08C268.268 166.809 268.777 166.685 269.313 166.708C269.855 166.734 270.379 166.894 270.887 167.187C271.394 167.48 271.791 167.853 272.079 168.305C272.373 168.761 272.523 169.266 272.53 169.819C272.537 170.372 272.379 170.929 272.055 171.49L271.548 172.368ZM270.718 170.456C270.98 170.002 271.062 169.584 270.965 169.202C270.871 168.813 270.633 168.509 270.251 168.288C269.869 168.068 269.486 168.014 269.103 168.127C268.723 168.233 268.402 168.514 268.14 168.967L267.406 170.239C267.144 170.692 267.06 171.113 267.154 171.502C267.251 171.884 267.491 172.186 267.873 172.406C268.255 172.627 268.636 172.684 269.016 172.577C269.4 172.464 269.722 172.181 269.984 171.727L270.718 170.456ZM273.744 173.898C273.483 174.352 273.402 174.775 273.502 175.167C273.605 175.553 273.845 175.854 274.221 176.071C274.645 176.316 275.023 176.383 275.357 176.274C275.695 176.158 276.001 175.862 276.277 175.384L277.539 176.113C277.236 176.638 276.867 177.03 276.431 177.288C276.005 177.543 275.55 177.662 275.066 177.646C274.586 177.623 274.113 177.477 273.648 177.209L273.522 177.136C273.009 176.84 272.61 176.47 272.324 176.027C272.039 175.584 271.897 175.092 271.899 174.552C271.904 174.005 272.074 173.443 272.408 172.864L272.914 171.987C273.238 171.425 273.636 171.006 274.106 170.729C274.577 170.451 275.074 170.321 275.598 170.337C276.128 170.356 276.64 170.509 277.136 170.795L277.261 170.867C277.739 171.143 278.107 171.483 278.367 171.888C278.636 172.29 278.768 172.744 278.762 173.25C278.76 173.75 278.6 174.275 278.283 174.824L276.967 174.064C277.236 173.598 277.335 173.186 277.264 172.827C277.202 172.465 276.977 172.172 276.59 171.948C276.214 171.731 275.831 171.677 275.441 171.786C275.061 171.893 274.74 172.173 274.478 172.627L273.744 173.898ZM282.112 173.787L280.489 176.599L284.324 175.064L285.872 175.958L282.31 177.352C282.328 178.492 282.338 179.15 282.34 179.326L282.389 182.136L280.822 181.232L280.8 177.9L279.492 178.326L278.566 179.929L277.214 179.149L280.76 173.007L282.112 173.787ZM283.125 182.561L286.671 176.419L290.995 178.916L290.207 179.929L287.396 178.306L286.62 179.649L289.243 181.163L288.608 182.265L285.984 180.75L285.121 182.245L287.959 183.884L287.476 185.073L283.125 182.561ZM294.349 180.852C294.856 181.145 295.254 181.518 295.542 181.971C295.835 182.427 295.986 182.931 295.993 183.484C296 184.038 295.841 184.595 295.517 185.156L295.114 185.854C294.79 186.415 294.387 186.831 293.904 187.101C293.422 187.372 292.91 187.494 292.368 187.468C291.832 187.445 291.31 187.287 290.803 186.994L288.475 185.65L292.021 179.508L294.349 180.852ZM290.499 185.35L291.439 185.893C291.821 186.113 292.202 186.17 292.582 186.063C292.965 185.95 293.288 185.667 293.55 185.214L294.181 184.121C294.442 183.668 294.525 183.25 294.427 182.867C294.333 182.479 294.095 182.174 293.713 181.954L292.773 181.411L290.499 185.35Z"
               fill="#6D6D6D"
            />
         </g>
         <g opacity="0.5">
            <rect
               x="188.093"
               y="236.714"
               width="49.144"
               height="19.7331"
               transform="rotate(-27.2789 188.093 236.714)"
               stroke="#6D6D6D"
               stroke-width="0.411915"
            />
            <path
               d="M202.348 243.441L199.763 238.429L200.896 237.845L202.998 241.922L205.058 240.859L205.665 241.73L202.348 243.441ZM209.118 237.23C209.354 237.688 209.459 238.137 209.433 238.576C209.406 239.015 209.268 239.41 209.017 239.761C208.772 240.11 208.442 240.391 208.028 240.604C207.614 240.818 207.191 240.925 206.76 240.925C206.333 240.923 205.933 240.806 205.56 240.573C205.187 240.34 204.883 239.994 204.647 239.536L204.277 238.82C204.041 238.362 203.936 237.914 203.963 237.475C203.989 237.036 204.125 236.642 204.371 236.293C204.621 235.942 204.954 235.66 205.368 235.446C205.782 235.233 206.202 235.127 206.629 235.129C207.06 235.128 207.462 235.245 207.835 235.478C208.208 235.711 208.513 236.057 208.749 236.514L209.118 237.23ZM207.482 236.964C207.291 236.594 207.047 236.359 206.749 236.26C206.449 236.156 206.143 236.184 205.831 236.345C205.519 236.506 205.319 236.738 205.23 237.044C205.138 237.344 205.187 237.679 205.378 238.049L205.913 239.087C206.104 239.457 206.35 239.694 206.65 239.798C206.948 239.897 207.253 239.866 207.564 239.706C207.876 239.545 208.078 239.315 208.17 239.014C208.259 238.709 208.208 238.372 208.017 238.001L207.482 236.964ZM211.086 236.419C211.277 236.789 211.525 237.025 211.83 237.127C212.133 237.223 212.438 237.193 212.744 237.034C213.09 236.856 213.298 236.632 213.368 236.361C213.436 236.086 213.369 235.753 213.169 235.364L214.199 234.832C214.42 235.261 214.523 235.676 214.508 236.079C214.496 236.473 214.38 236.829 214.161 237.145C213.94 237.457 213.639 237.711 213.259 237.907L213.157 237.959C212.738 238.175 212.319 238.284 211.9 238.284C211.481 238.284 211.091 238.168 210.73 237.935C210.367 237.696 210.063 237.341 209.819 236.869L209.45 236.153C209.214 235.695 209.104 235.249 209.121 234.815C209.138 234.381 209.264 233.992 209.5 233.648C209.741 233.302 210.063 233.025 210.468 232.816L210.57 232.764C210.959 232.563 211.346 232.462 211.728 232.462C212.113 232.455 212.473 232.562 212.809 232.783C213.143 233 213.425 233.332 213.656 233.78L212.582 234.334C212.386 233.954 212.153 233.711 211.882 233.604C211.613 233.49 211.321 233.514 211.004 233.677C210.697 233.836 210.497 234.068 210.402 234.376C210.311 234.676 210.36 235.011 210.551 235.382L211.086 236.419ZM214.609 230.773L215.792 233.068L216.413 229.843L217.677 229.191L217.078 232.173C217.849 232.651 218.294 232.927 218.412 233.002L220.313 234.177L219.034 234.836L216.796 233.419L216.519 234.478L217.193 235.786L216.09 236.354L213.505 231.342L214.609 230.773ZM220.913 233.867L218.329 228.855L221.858 227.035L222.197 227.998L219.903 229.181L220.468 230.277L222.608 229.173L223.072 230.072L220.931 231.176L221.56 232.396L223.876 231.201L224.464 232.036L220.913 233.867ZM224.595 225.624C225.009 225.41 225.429 225.304 225.856 225.307C226.287 225.306 226.689 225.422 227.062 225.655C227.435 225.889 227.74 226.234 227.976 226.692L228.27 227.262C228.506 227.72 228.611 228.168 228.584 228.607C228.558 229.046 228.42 229.441 228.169 229.793C227.923 230.141 227.594 230.422 227.179 230.636L225.28 231.615L222.695 226.603L224.595 225.624ZM225.949 230.133L226.716 229.737C227.028 229.576 227.23 229.346 227.321 229.046C227.411 228.741 227.36 228.403 227.169 228.033L226.709 227.142C226.519 226.771 226.274 226.537 225.976 226.437C225.676 226.333 225.37 226.362 225.058 226.522L224.291 226.918L225.949 230.133Z"
               fill="#6D6D6D"
            />
         </g>
         <g opacity="0.5">
            <rect
               x="180.565"
               y="120.069"
               width="84.5346"
               height="33.9437"
               transform="rotate(-30 180.565 120.069)"
               stroke="#6D6D6D"
               stroke-width="0.708552"
            />
            <path
               d="M205.707 130.68L200.857 122.279L202.755 121.183L206.7 128.017L210.153 126.023L211.266 127.47L205.707 130.68ZM216.832 119.456C217.275 120.224 217.492 120.986 217.483 121.742C217.473 122.499 217.267 123.189 216.866 123.813C216.472 124.432 215.928 124.942 215.234 125.343C214.54 125.743 213.823 125.962 213.082 125.998C212.349 126.029 211.652 125.86 210.992 125.49C210.332 125.119 209.781 124.551 209.338 123.783L208.645 122.583C208.202 121.816 207.985 121.054 207.994 120.297C208.004 119.541 208.205 118.853 208.599 118.234C209.001 117.61 209.549 117.098 210.243 116.697C210.937 116.296 211.65 116.08 212.383 116.049C213.124 116.013 213.825 116.18 214.485 116.55C215.145 116.92 215.696 117.489 216.139 118.256L216.832 119.456ZM214 119.132C213.642 118.512 213.203 118.128 212.683 117.982C212.158 117.828 211.635 117.902 211.112 118.203C210.59 118.505 210.264 118.921 210.136 119.453C210.002 119.976 210.115 120.548 210.473 121.168L211.477 122.907C211.835 123.528 212.277 123.915 212.801 124.07C213.321 124.216 213.842 124.138 214.365 123.836C214.887 123.535 215.215 123.122 215.348 122.599C215.477 122.068 215.362 121.492 215.004 120.871L214 119.132ZM220.147 117.902C220.506 118.522 220.951 118.907 221.484 119.057C222.012 119.198 222.533 119.12 223.047 118.824C223.627 118.489 223.966 118.086 224.064 117.616C224.158 117.137 224.016 116.571 223.639 115.918L225.366 114.921C225.781 115.64 225.992 116.345 226 117.037C226.011 117.716 225.841 118.337 225.491 118.899C225.135 119.452 224.639 119.913 224.002 120.28L223.831 120.379C223.129 120.785 222.418 121.005 221.698 121.039C220.978 121.074 220.298 120.906 219.659 120.535C219.016 120.155 218.465 119.569 218.008 118.778L217.315 117.577C216.872 116.81 216.647 116.053 216.64 115.306C216.633 114.558 216.819 113.88 217.196 113.27C217.581 112.656 218.113 112.153 218.79 111.762L218.962 111.663C219.615 111.286 220.27 111.082 220.927 111.051C221.588 111.007 222.216 111.161 222.811 111.514C223.402 111.859 223.914 112.407 224.348 113.158L222.548 114.197C222.18 113.56 221.759 113.161 221.285 113C220.814 112.825 220.313 112.891 219.783 113.197C219.268 113.494 218.943 113.911 218.806 114.447C218.673 114.97 218.785 115.542 219.143 116.163L220.147 117.902ZM225.739 107.914L227.959 111.759L228.764 106.167L230.882 104.944L230.097 110.116C231.46 110.875 232.246 111.314 232.456 111.432L235.818 113.295L233.675 114.533L229.713 112.281L229.323 114.122L230.589 116.314L228.74 117.382L223.89 108.981L225.739 107.914ZM236.824 112.714L231.974 104.314L237.889 100.899L238.55 102.525L234.705 104.745L235.765 106.582L239.354 104.511L240.223 106.017L236.635 108.088L237.816 110.134L241.698 107.892L242.776 109.278L236.824 112.714ZM242.477 98.2499C243.171 97.8492 243.884 97.6333 244.617 97.6019C245.358 97.5659 246.059 97.7329 246.719 98.103C247.379 98.473 247.93 99.0418 248.373 99.8092L248.925 100.764C249.368 101.532 249.585 102.294 249.575 103.05C249.566 103.807 249.36 104.497 248.958 105.121C248.565 105.74 248.021 106.25 247.327 106.651L244.143 108.489L239.293 100.088L242.477 98.2499ZM245.171 105.887L246.457 105.144C246.98 104.843 247.308 104.43 247.441 103.907C247.57 103.376 247.455 102.8 247.097 102.179L246.234 100.685C245.876 100.065 245.437 99.6814 244.917 99.5352C244.392 99.3808 243.869 99.4545 243.346 99.7562L242.061 100.499L245.171 105.887Z"
               fill="#6D6D6D"
            />
         </g>
         <path
            d="M188.862 183.69C188.862 180.853 191.163 178.091 194.478 178.091L194.478 177.491C190.8 177.491 188.262 180.553 188.262 183.69L188.862 183.69Z"
            fill="black"
         />
         <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M203.588 183.459C203.588 188.335 199.635 192.288 194.759 192.288C189.884 192.288 185.931 188.335 185.931 183.459C185.931 178.584 189.884 174.631 194.759 174.631C199.635 174.631 203.588 178.584 203.588 183.459ZM202.588 183.459C202.588 187.783 199.083 191.288 194.759 191.288C190.436 191.288 186.931 187.783 186.931 183.459C186.931 179.136 190.436 175.631 194.759 175.631C199.083 175.631 202.588 179.136 202.588 183.459Z"
            fill="black"
         />
         <path
            d="M137.592 203.915C180.59 244.299 308.831 240.256 346.189 203.915"
            stroke="#323232"
            stroke-width="9"
            stroke-linecap="round"
            stroke-linejoin="round"
         />
         <path
            d="M137.638 204.363C177.98 243.648 308.866 240.139 343.958 205.966"
            stroke="#F79E85"
            stroke-width="7"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="12 7"
         />
         <rect
            x="125.877"
            y="201.342"
            width="13.3067"
            height="15.01"
            rx="2.65"
            transform="rotate(-46.782 125.877 201.342)"
            fill="#FCC823"
            stroke="black"
            stroke-width="0.7"
         />
         <path
            d="M132.949 197.84C134.839 195.693 135.811 195.336 137.798 197.693"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
         />
         <rect
            x="-0.494735"
            y="-0.0153925"
            width="13.3067"
            height="15.01"
            rx="2.65"
            transform="matrix(-0.684776 -0.728754 -0.728754 0.684776 358.555 200.25)"
            fill="#FCC823"
            stroke="black"
            stroke-width="0.7"
         />
         <path
            d="M352.104 197.098C350.214 194.951 349.243 194.595 347.256 196.951"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
         />
         <rect x="86.6667" y="272.423" width="314.852" height="4.76553" fill="white" />
         <rect x="0.0666504" y="271.829" width="488.053" height="1" fill="black" />
      </svg>
   `, this.title = "User Identification Error", this.message = "We are unable to identify your user identity for some reason, please login and try again.", this.buttonText = "Login", this.handleGoBack = () => {
      this.dispatchEvent(new CustomEvent("click-login"));
    };
  }
  render() {
    return d`
         <div class="page-container">
            <div class="page-content">
               <div class="page-illustration">${this.illustrationSVG}</div>
               <h2 id="title">${this.title}</h2>
               <span class="page-massage">
                  <p>${this.message}</p>
               </span>
               <button id="login" @click=${this.handleGoBack}>${this.buttonText}</button>
            </div>
            <page-footer></page-footer>
         </div>
      `;
  }
  static get styles() {
    return L`
         ${c(f)}
      `;
  }
};
o([
  l({ type: String })
], e.prototype, "title", 2);
o([
  l({ type: String })
], e.prototype, "message", 2);
o([
  l({ type: String })
], e.prototype, "buttonText", 2);
e = o([
  p("page-error-auth-failed")
], e);
export {
  e as PageErrorAuthFailedElement
};
//# sourceMappingURL=index.js.map
